module.exports = __webpack_public_path__ + "static/land7.f3d137ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/other/landings/thumb/land7.png
// module id = 207
// module chunks = 35783957827783 246384609461072